import { render, staticRenderFns } from "./index.vue?vue&type=template&id=109b6d0c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../AppBreadcrumb/breadcrumb.locale.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2F_work%2Fdash-webapp%2Fdash-webapp%2Fsrc%2Fcomponents%2Fproject%2Fui%2FAppNavigationBar%2Findex.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports